import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FieldComponent, DateField } from '@jutro/components';
// TDIC:  classNames imported
import classNames from 'classnames';
import dateRangeStyles from './DateRangeComponent.module.scss';

class DateRangeComponent extends FieldComponent {
    /**
     * @memberof gw-components-platform-react.DateRangeComponent
     * @prop {Object} propTypes - the props that are passed to this component
     * @prop {boolean} propTypes.fromDate - prop name of the value to be taken from the value obj
     * @prop {boolean} propTypes.toDate - prop name of the value to be taken from the value obj
     * @prop {Object} propTypes.value - value of the base object which
     * contains paths for toDate and fromDate
     */
    static propTypes = {
        ...FieldComponent.propTypes,
        fromDate: PropTypes.string.isRequired,
        toDate: PropTypes.string.isRequired,
        value: PropTypes.shape({}).isRequired,
        // TDIC: dateClassName PropTypes added
        dateClassName: PropTypes.shape({})
    };

    render() {
        return super.render();
    }

    renderControl() {
        const {
            // TDIC: dateClassName addded
            fromDate, toDate, value, id, dateClassName
        } = this.props;

        const startDate = _.get(value, fromDate);
        const endDate = _.get(value, toDate);
        // #region
        // TDIC: startDateClasses and endDateClasses added
        const startDateClasses = classNames(dateRangeStyles.startDateValue, dateClassName);
        const endDateClasses = classNames(dateRangeStyles.endDateValue, dateClassName);
        // #endregion

        return (
            <div className={dateRangeStyles.dateRangeContainer} id={id}>
                <DateField
                    id={`${id}_startDateInRange`}
                    // className={dateRangeStyles.startDateValue} TDIC: replaced classname
                    className={startDateClasses}
                    value={startDate}
                    format="short"
                    dataType={_.isString(startDate) ? 'string' : 'object'}
                    readOnly
                    hideLabel
                    layout="full-width"
                    showOptional={false}
                />
                <span> - </span>
                <DateField
                    id={`${id}_endDateInRange`}
                    // className={dateRangeStyles.endDateValue}TDIC: this line is removed
                    className={endDateClasses}
                    value={endDate}
                    format="short"
                    dataType={_.isString(endDate) ? 'string' : 'object'}
                    readOnly
                    hideLabel
                    layout="full-width"
                    showOptional={false}
                />
            </div>
        );
    }
}

export default DateRangeComponent;
